// 请不要改动这个文件，如果需要在Vue.prototype上添加方法或者变量，请团队沟通

import { baseUrl } from '@/ajax/baseUrl';

import Device from '@/framework/utils-project/jsBridge/device';

import * as yhcAjax from '@/ajax/index';

let setVuePrototypeData = {};

let a123 = [];
let a789 = {
  avatar: 'https://file.softbuilder.cn/official/contents/images/au-1.png',
  avatarList: [
    'https://file.softbuilder.cn/official/contents/images/au-2.png',
    'https://file.softbuilder.cn/official/contents/images/au-3.png',
    'https://file.softbuilder.cn/official/contents/images/au-4.png',
  ],
  video: 'https://file.softbuilder.cn/official/contents/images/llmPrevlong.mp4',
  date: '2025-09-25',
  dateTime: '2025-09-25 12:34:56',
  money: '88.99',
  id: '8',
  phone: '13088881234',
  userName: '一条大象',
  otherText: `其他文案 other text`,
  numText: `3999`,
  colorText: `#FFFFFF`,
};
for (let index = 0; index < 5; index++) {
  a123.push(a789);
}

setVuePrototypeData.install = function (Vue, options) {
  // 全局定义的数据一定要写注释，越详细越好
  Vue.prototype.yhcMockList = window.yhcMockList = a123;
  Vue.prototype.yhcMockItem = window.yhcMockItem = a789;

  Vue.prototype.yhcAjax = yhcAjax;

  // 判断是否开发环境
  Vue.prototype.yhcIsDev = window.yhcIsDev = window.location.origin.indexOf('192.') != -1;

  // let staticPath = window.yhcIsDev ? '' : '/server/static/';
  let staticPath = window.yhcIsDev ? '' : '/dist/';
  Vue.prototype.yhcPort = window.yhcPort = baseUrl + staticPath;

  // 全局的loading数量计数
  Vue.prototype.yhcLoadingCount = window.yhcLoadingCount = 0;
  // elementui的Toast组件实例
  Vue.prototype.yhcToastInstance = window.yhcToastInstance = null;
  // elementui的Loading组件实例
  Vue.prototype.yhcLoadingInstance = window.yhcLoadingInstance = null;

  // 设备系统信息
  Vue.prototype.yhcSysInfo = window.yhcSysInfo = {
    isIos: Device.ios,
    isAndroid: Device.android,
    isDesktop: Device.desktop,
    // ios / android / windows
    os: Device.os,
    // x.x.x
    osVersion: Device.osVersion,
  };
};

export default setVuePrototypeData;
